/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'gas': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M0 0h20v20H0z"/><path pid="1" d="M16.605 3H2.395a.392.392 0 00-.28.117A.403.403 0 002 3.4v13.2c0 .106.042.208.116.283a.392.392 0 00.279.117h14.21a.392.392 0 00.28-.117A.403.403 0 0017 16.6V3.4a.403.403 0 00-.116-.283.392.392 0 00-.279-.117zm-.79 1.2v4.868H14.7a.988.988 0 00-.936.676l-.395 1.2-.71-2.028a.985.985 0 00-.888-.672.966.966 0 00-.944.588l-1.61 3.6-1.433-5.324a.991.991 0 00-.848-.745.984.984 0 00-.988.541L4.511 9.636H3.184V4.2h12.632zM3.186 15.8v-4.968H4.64c.365 0 .7-.202.872-.528l1.26-2.4 1.456 5.38c.104.412.457.71.876.74h.083a.974.974 0 00.896-.588l1.63-3.636.719 2.096c.135.404.51.675.931.672a.976.976 0 00.932-.676l.545-1.6h.975V15.8H3.184z" _fill="currentColor" fill-rule="nonzero"/></g>'
  }
})
